import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { addEventListener as _$addEventListener } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<button type=button class=duel-outcome__rematch data-testid=duel-rematch>REMATCH`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class=duel-outcome data-testid=duel-outcome><h2 class=duel-outcome__banner></h2><p class=duel-outcome__note></p><div class=duel-outcome__actions><button type=button class=duel-outcome__exit data-testid=duel-exit>LEAVE`),
  _tmpl$3 = /*#__PURE__*/_$template(`<p class=duel-outcome__hint>`);
import { Show } from "solid-js";
import { DUEL_EXPLANATIONS, duelBanner } from "./duel-outcome.ts";

/**
 * The end of a duel: what happened, why, and the two ways out.
 *
 * Deliberately not `DebriefOverlay` — that one reports a *mission* (objectives,
 * kills, a score credited to a career), and a duel has none of those. What a
 * duel owes the player instead is an explanation of endings a single-player
 * fight cannot have: a divergence, or a peer that vanished.
 */

export function DuelOutcomeOverlay(props) {
  return _$createComponent(Show, {
    get when() {
      return duelBanner(props.outcome);
    },
    children: banner => (() => {
      var _el$ = _tmpl$2(),
        _el$2 = _el$.firstChild,
        _el$3 = _el$2.nextSibling,
        _el$4 = _el$3.nextSibling,
        _el$6 = _el$4.firstChild;
      _$insert(_el$2, banner);
      _$insert(_el$3, () => DUEL_EXPLANATIONS[props.outcome]);
      _$insert(_el$4, _$createComponent(Show, {
        get when() {
          return props.canRematch;
        },
        get fallback() {
          return (() => {
            var _el$7 = _tmpl$3();
            _$insert(_el$7, () => props.rematchHint);
            return _el$7;
          })();
        },
        get children() {
          var _el$5 = _tmpl$();
          _$addEventListener(_el$5, "click", props.onRematch, true);
          return _el$5;
        }
      }), _el$6);
      _$addEventListener(_el$6, "click", props.onExit, true);
      return _el$;
    })()
  });
}
_$delegateEvents(["click"]);